import catalogHoursGateAtom from "../catalog-hours-gate";
import categoriesAtom from "../categories";
import { createVisibleItemOffersAtom } from "../create-visible-catalog-atoms";
import itemOffersAtom from "../item-offers";

/** DELIVERY offers searchable right now (offer window + owning category window). */
const visibleItemOffersAtom = createVisibleItemOffersAtom(
  categoriesAtom,
  itemOffersAtom,
  catalogHoursGateAtom,
);

export default visibleItemOffersAtom;
